var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M47.56.44a1.5 1.5 0 010 2.12l-45 45a1.5 1.5 0 01-2.12-2.12l45-45a1.5 1.5 0 012.12 0z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31.5 1.5A1.5 1.5 0 0133 0h13.5A1.5 1.5 0 0148 1.5V15a1.5 1.5 0 01-3 0V3H33a1.5 1.5 0 01-1.5-1.5zm-30 30A1.5 1.5 0 013 33v12h12a1.5 1.5 0 010 3H1.5A1.5 1.5 0 010 46.5V33a1.5 1.5 0 011.5-1.5zM.44.44a1.5 1.5 0 012.12 0l45 45a1.5 1.5 0 01-2.12 2.12l-45-45a1.5 1.5 0 010-2.12z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 1.5A1.5 1.5 0 011.5 0H15a1.5 1.5 0 010 3H3v12a1.5 1.5 0 01-3 0V1.5zm46.5 30A1.5 1.5 0 0148 33v13.5a1.5 1.5 0 01-1.5 1.5H33a1.5 1.5 0 010-3h12V33a1.5 1.5 0 011.5-1.5z","key":2})]);
}

Expand.defaultProps = {"viewBox":"0 0 48 49"};

module.exports = Expand;

Expand.default = Expand;
